import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { EnquiryModal } from "@/components/overlays/EnquiryModal";

export const FloatingContact = ({ config }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-4 right-4 z-30 sm:bottom-6 sm:right-6">
        <button
          type="button"
          onClick={() => setOpen(true)}
          data-testid="floating-contact-button"
          aria-label="Ask Goldmap a question"
          className="inline-flex min-h-[48px] items-center gap-2 rounded-xl px-4 text-sm font-semibold text-white"
          style={{
            background: "#0a1230",
            border: "1px solid rgba(255,255,255,0.18)",
          }}
        >
          <MessageCircle className="h-4 w-4" style={{ color: "var(--gm-red)" }} />
          Ask us
        </button>
      </div>
      <EnquiryModal open={open} onOpenChange={setOpen} config={config} />
    </>
  );
};
